jQuery(document).ready(function($) {

    $( ".bloc_competences" ).each(function() {

        $(this).find(".competences_container").each(function() {

            let $container = $(this)
            let track = $container.find(".competences_track")
            let original = track.find(".competences_slider:not(.duplicated)").first()
            let count = original.find(".competence").length

            // On repart d'un état propre : on retire les copies éventuelles
            track.find(".competences_slider.duplicated").remove()

            // Moins de 4 compétences : pas de slide, grille centrée
            if (count < 4) {
                $container.addClass("is-grid")
                return
            }

            // 4+ : marquee infini.
            // On génère assez de copies pour couvrir l'écran sans saut au rebouclage :
            // au moins 3 sliders (triple), davantage si l'écran est plus large que le slider.
            let width = original.outerWidth()
            let copies = Math.max(3, Math.ceil(window.innerWidth / width) + 1)

            for (let i = 1; i < copies; i++) {
                original.clone()
                    .addClass("duplicated")
                    .attr("aria-hidden", "true")
                    .appendTo(track)
            }

            // Translation d'exactement une largeur de slider : le rebouclage est invisible
            // car le slider suivant occupe alors la position du premier.
            let speed = 70
            let tl = gsap.fromTo(track,
                { x: 0 },
                { x: -width, ease: "none", duration: speed, repeat: -1 }
            )

            $container
                .on("mouseenter", function () { tl.pause() })
                .on("mouseleave", function () { tl.play() })

        })

    })

});
